import type { VisitRecord } from '.';

/**
 * Increment count of times player has visited a friend
 * @param state Player state
 * @param friendId the friend being visited by the player
 * @param now the current time
 * @return the new visit count
 */
export function incrementVisitsCount(
  state: VisitRecord.MutableState,
  friendId: string,
  now: number,
) {
  const { visits } = state.visit;
  const currentCount = visits[friendId]?.count ?? 0;
  visits[friendId] = {
    count: currentCount + 1,
    lastUpdatedAt: now,
    lastGemsGrantAt: visits[friendId]?.lastGemsGrantAt ?? 0,
  };

  return visits[friendId].count;
}

/**
 * Increment count of times player has been visited by a friend
 * @param params.friendId the friend visiting the player
 * @param params.name display name of the visiting friend
 * @param params.now the current time
 * @return the new visited count
 */
export function incrementVisitedCount(
  state: VisitRecord.MutableState,
  params: {
    friendId: string;
    name: string;
    now: number;
  },
) {
  const { friendId, name, now } = params;
  const { visited } = state.visit;
  const currentCount = visited[friendId]?.count ?? 0;

  visited[friendId] = {
    name,
    count: currentCount + 1,
    lastUpdatedAt: now,
  };

  return visited[friendId].count;
}
